/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @description
 *
 * @created at Mon Dec 18 2024
 **/
import { _P } from "@rfice/language";
import {
	ChannelCreateSystemChatWrapper,
	ChannelCreateSystemMessage
} from "@/frameworks/core/components/Chat/private/components/SystemRendererItem/emotion";
import { Row, Typography } from "@/frameworks/designStuff/components";

interface ChannelCreateSystemChatProps {
	systemForm: ChatServices.Format2.System.ChannelCreate;
	variant: ChatUI.Size;
}

/**
 * Channel create system chat component
 * @param systemForm
 * @constructor
 * @author: DQTuan
 */
const ChannelCreateSystemChat = ({ systemForm, variant }: ChannelCreateSystemChatProps) => {
	return variant === "transparent" ? (
		<ChannelCreateSystemChatWrapper>
			<ChannelCreateSystemMessage>
				{_P("{{roomName}} 채널이 생성되었습니다.", { roomName: systemForm.data.roomName })}
			</ChannelCreateSystemMessage>
		</ChannelCreateSystemChatWrapper>
	) : (
		<Typography.div
			typoSize="Body2"
			style={{
				flexWrap: "wrap",
				fontWeight: "bold",
				borderRadius: "12px",
				padding: "8px 16px",
				backgroundColor: "transparent",
				margin: "4px 0"
			}}
		>
			<Row gap={10} verticalAlign="center">
				<Typography.div typoSize="Title2" style={{ wordBreak: "break-all" }}>
					{_P("{{roomName}} 채널이 생성되었습니다.", { roomName: systemForm.data.roomName })}
				</Typography.div>
			</Row>
		</Typography.div>
	);
};

export default ChannelCreateSystemChat;
